import React, { useContext, useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import S from './style';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import Slider from 'react-slick';
import data from '../../services/data';
import dataen from '../../services/dataen';
import { LocaleContext } from '../../locale-context';
import TranslateStatic from '../../locales/TranslateStatic';

export function Product(props) {
  let { subcatid, catid, name } = useParams();
  const value = useContext(LocaleContext);
  const [result, setResult] = useState(false);
  const [current, setCurrent] = useState('');

  useEffect(() => {
    let filterdata, filterdata2;
    if (value === "en") {
      filterdata = dataen.find(element => element.category.id == catid);
      if (filterdata) {
        filterdata2 = filterdata.category.subcategories.find(element => element.id == subcatid);
        setResult(filterdata2);
      }
    } else if (value === "tr") {
      filterdata = data.find(element => element.category.id == catid);
      if (filterdata) {
        filterdata2 = filterdata.category.subcategories.find(element => element.id == subcatid);
        setResult(filterdata2);
      }
    } else {
      filterdata = dataen.find(element => element.category.id == catid);
      if (filterdata) {
        filterdata2 = filterdata.category.subcategories.find(element => element.id == subcatid);
        setResult(filterdata2);
      }
    }
  }, [catid, subcatid, value]);

  function handleClickImage(e, image) {
    e && e.preventDefault();
    setCurrent(image);
  }

  function handleCloseModal(e) {
    e && e.preventDefault();
    setCurrent('');
  }

  const settings = {
    customPaging: function (i) {
      if (result && result.imgsrc && result.imgsrc[i]) {
        return (
          <a>
            <img src={result.imgsrc[i]} alt="thumbnail" />
          </a>
        );
      }
      return <a></a>;
    },
    dots: true,
    dotsClass: "slick-dots slick-thumb custom-paging",
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    adaptiveHeight: true
  };

  const decodedName = name ? decodeURIComponent(name).replace(/-/g, ' ') : (result ? result.name : "Detay");

  return (
    <S.PageWrapper>
      <S.HeroSection>
        <div className="hero-content">
          <h1>{decodedName}</h1>
          <S.Breadcrumb>
            <Link to="/"><TranslateStatic string="home" /></Link>
            <span className="separator">/</span>
            <span>{decodedName}</span>
          </S.Breadcrumb>
        </div>
      </S.HeroSection>

      <S.ContentWrapper>
        <div className="info-container">
          <div className="text-content">
            {result && result.detail}
          </div>

          {result && result.imgsrc && result.imgsrc.length > 0 && (
            <div className="slider-wrapper">
              <Slider {...settings}>
                {result.imgsrc.map((image, index) => (
                  <div key={index}>
                    <img src={image} onClick={e => handleClickImage(e, image)} alt="slide" />
                  </div>
                ))}
              </Slider>
            </div>
          )}
        </div>
      </S.ContentWrapper>

      {/* Lightbox Implementation (if needed, already imported) */}
      {current && (
        <Lightbox
          mainSrc={current}
          onCloseRequest={handleCloseModal}
        />
      )}
    </S.PageWrapper>
  );
}
